import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserAccountSettingsState } from './user-account-settings.reducer';
import * as moment from 'moment-timezone';
import { USER_ACCOUNT_SETTINGS_FEATURE_KEY } from './user-account-settings.feature';

export const selectUserState = createFeatureSelector<UserAccountSettingsState>(
  USER_ACCOUNT_SETTINGS_FEATURE_KEY,
);

export const settings = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.user?.settings ?? null,
);

export const email = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.user?.email ?? null,
);

export const userProfile = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.user,
);

export const selectUser = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.user,
);

export const selectUserTimezone = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => {
    const browserTZ = moment.tz.guess();
    return state.user?.timezone ?? browserTZ;
  },
);

export const selectIsLoginLoading = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.isLoginLoading,
);

export const selectIsSaving = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.isSaving,
);

export const selectUserSettings = createSelector(
  selectUserState,
  (state: UserAccountSettingsState) => state.userSettings,
);
